module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Next&Co","short_name":"Next&Co","start_url":"/","background_color":"#000000","theme_color":"#000000","display":"fullscreen","icon":"src/images/nextandco-icon.png","cache_busting_mode":"query","include_favicon":true,"legacy":true,"theme_color_in_head":true,"cacheDigest":"b8c69d785e94eff111e2382a30f63ad3"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
